// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GoogleWorkspaceIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="#4285F4"
      d="M45.12 24.5q0-2.34-.4-4.5H24v8.52h11.84a10.1 10.1 0 0 1-4.42 6.62v5.54h7.14c4.16-3.84 6.56-9.48 6.56-16.18"
    />
    <path
      fill="#34A853"
      d="M24 46c5.94 0 10.92-1.96 14.56-5.32l-7.14-5.54A13 13 0 0 1 24 37.26a13.1 13.1 0 0 1-12.32-9.06H4.36v5.68A22 22 0 0 0 24 46"
    />
    <path
      fill="#FBBC05"
      d="M11.68 28.18c-.44-1.32-.7-2.72-.7-4.18s.26-2.86.7-4.18v-5.68H4.36a21.7 21.7 0 0 0 0 19.72l5.7-4.44z"
    />
    <path
      fill="#EA4335"
      d="M24 10.76a12 12 0 0 1 8.42 3.28l6.3-6.3A21 21 0 0 0 24 2C15.4 2 7.98 6.94 4.36 14.14l7.32 5.68c1.74-5.2 6.6-9.06 12.32-9.06"
    />
  </svg>,
  "GoogleWorkspace",
);
export default GoogleWorkspaceIcon;
